// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/FranchisorChannels_TriggersResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * FranchisorChannels_TriggersResponse — GET /franchisor-channels/triggers.
 * The full catalog matrix: FranchisorTriggerCatalog::all() entries in a
 * fixed order, each carrying its current bindings.
 */
import type { FranchisorChannels_TriggerRow } from './FranchisorChannels_TriggerRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface FranchisorChannels_TriggersResponseDados {
rows: FranchisorChannels_TriggerRow[]
}

export type FranchisorChannels_TriggersResponse = ApiResponse<FranchisorChannels_TriggersResponseDados>;

registerResponseContract('FranchisorChannels_TriggersResponse', {
  rows: {
    type: 'array',
    required: true,
    items: {
      trigger_key: { type: 'string',  required: false },
      implemented: { type: 'boolean', required: false },
      vars:        { type: 'array',   required: false },
      bindings: {
        type: 'array',
        required: false,
        items: {
          id:               { type: 'number',  required: true },
          trigger_key:      { type: 'string',  required: false },
          channel_id:       { type: 'number',  required: true },
          channel_type:     { type: 'string',  required: false },
          template_id:      { type: 'number',  required: true },
          recipient_groups: { type: 'array',   required: false },
          enabled:          { type: 'boolean', required: false },
          created_at:       { type: 'string',  required: false },
          updated_at:       { type: 'string',  required: false },
        },
      },
    },
  },
})
